// Canais de notificação Android criados pelo app (messaging_service.dart).
// 'orders' existe, mas é reservado aos pedidos do cardápio e não entra em campanha.

export interface PushChannel {
  id: string;
  label: string;
  sound: boolean;
  /** Primeira versão do app que cria o canal. Antes dela o Android usa o canal "Diversos", que toca som. */
  minAppVersion?: string;
}

export const DEFAULT_CHANNEL_ID = 'high_importance_channel';
export const SILENT_CHANNEL_ID = 'silent';

export const PUSH_CHANNELS: PushChannel[] = [
  { id: DEFAULT_CHANNEL_ID, label: 'Importantes (som + destaque)', sound: true },
  { id: SILENT_CHANNEL_ID, label: 'Silenciosas (sem som)', sound: false, minAppVersion: '1.12.0' },
];

export const findPushChannel = (id: string): PushChannel | undefined =>
  PUSH_CHANNELS.find(channel => channel.id === id);

/** Validade da notificação no FCM (se o aparelho estiver offline por mais tempo, ela é descartada). */
export const TTL_OPTIONS: { value: number; label: string }[] = [
  { value: 3600, label: '1 hora' },
  { value: 86400, label: '1 dia' },
  { value: 604800, label: '1 semana' },
  { value: 2419200, label: '4 semanas (padrão)' },
];

export const DEFAULT_TTL_SECONDS = 2419200;
